'use client';

import {
  Avatar,
  Box,
  Button,
  Center,
  Divider,
  HStack,
  Icon,
  IconButton,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from '@chakra-ui/react';
import { CaretDown, List, Question, SignOut, SlackLogo } from '@phosphor-icons/react';
import React from 'react';
import { UserProfile } from '@auth0/nextjs-auth0/client';
import Link from 'next/link';
import { SLACK_URL } from '@/src/app/constants';

type Props = {
  onClickMenuButton?: () => void;
  menuButtonIcon?: typeof List;
  user?: UserProfile;
};

export const Navbar: React.FC<Props> = ({ onClickMenuButton, user, menuButtonIcon = List }) => {
  return (
    <HStack p={6} w={'full'} justifyContent={'space-between'}>
      <HStack>
        {onClickMenuButton && (
          <IconButton
            onClick={() => onClickMenuButton()}
            size={'xl'}
            colorScheme={'neutral'}
            variant={'opacityIcon'}
            aria-label={'menu'}
            icon={<Icon h={5} w={5} as={menuButtonIcon} />}
          />
        )}

        <Link href={'/'}>
          <Image alt={'Livecycle'} h={6} w={40} src={'/livecycle-logo.svg'} />
        </Link>
      </HStack>
      <Center gap={1}>
        <Link
          href={SLACK_URL}
          target={'_blank'}
        >
          <Button
            iconSpacing={1}
            size={'xl-a'}
            colorScheme={'neutral'}
            aria-label={'help-btn'}
            variant={'text'}
            leftIcon={<Icon as={SlackLogo} h={'16px'} w={'16px'} />}
          >
            Support
          </Button>
        </Link>
        <Link href={'https://preevy.dev/'} target={'_blank'}>
          <Button
            iconSpacing={1}
            size={'xl-a'}
            colorScheme={'neutral'}
            aria-label={'help-btn'}
            variant={'text'}
            leftIcon={<Icon as={Question} h={'16px'} w={'16px'} />}
          >
            Help
          </Button>
        </Link>
        {user && (
          <>
            <Avatar name={user?.name || undefined} src={user?.picture || undefined} borderRadius={'4px'} size={'xs'} />
            <Menu variant={'lcMenuRD'}>
              <MenuButton
                as={IconButton}
                aria-label="Options"
                icon={<Icon as={CaretDown} weight="bold" />}
                variant="opacityIcon"
                size={'xl'}
              />
              <MenuList>
                <MenuItem _hover={{ bg: 'transparent' }} cursor={'default'} pointerEvents={'none'}>
                  <Center gap={2}>
                    <Avatar
                      name={user?.name || undefined}
                      src={user?.picture || undefined}
                      borderRadius={'8px'}
                      size={'md'}
                    />
                    <Box>
                      <Text textColor={'lc.system.secondary.80'} textStyle={'label-lg'}>
                        {user?.name}
                      </Text>
                      <Text textColor={'lc.system.secondary.80'} textStyle={'body-sm'}>
                        {user?.email}
                      </Text>
                    </Box>
                  </Center>
                </MenuItem>
                <Divider my={2} />
                <a href={'/api/auth/logout'}>
                  <MenuItem icon={<Icon as={SignOut} weight="bold" />}>Log out</MenuItem>
                </a>
              </MenuList>
            </Menu>
          </>
        )}
      </Center>
    </HStack>
  );
};
